import { ReactNode } from 'react';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { Stack, Typography } from '@mui/material';

import { Box, Card, HelpTip, InfoIcon, TextField } from '@occc-app/design-system';

import {
  referralCodePlaceholder,
  referralLinkPlaceholder,
} from '../award-configuration/award-configuration.constants';
import { ReferralProgramConfigurationValuesPaths } from '../../referral-program-configuration.types';

type MarketingContentFormProps = {
  fieldNamePrefix: `marketingContents.${number}`;
};

const SectionHeader = (props: { icon: ReactNode; title: string }) => (
  <Stack direction='row' alignItems='center' spacing={1}>
    <Box
      display='flex'
      alignItems='center'
      justifyContent='center'
      borderRadius='50%'
      bgcolor='primary.main'
      color='primary.contrastText'
      width={32}
      height={32}
    >
      {props.icon}
    </Box>
    <Typography fontWeight='bold'>{props.title}</Typography>
  </Stack>
);

export const MarketingContentForm = ({ fieldNamePrefix }: MarketingContentFormProps) => {
  return (
    <Stack component={Card} p={3} spacing={4} mb={0}>
      <Stack spacing={2}>
        <SectionHeader icon={<SendOutlinedIcon fontSize='small' />} title='Sender' />
        <TextField
          label='Instructions for Sender'
          name={
            `${fieldNamePrefix}.senderInstructions` satisfies ReferralProgramConfigurationValuesPaths
          }
        />
        <HelpTip
          icon={<InfoIcon color='primary' />}
          title='Add copy to let the sender know what referral incentive they’re getting and what conditions have to be met'
        />
      </Stack>

      <Stack spacing={2}>
        <SectionHeader icon={<EmailOutlinedIcon fontSize='small' />} title='Receiver' />
        <TextField
          label='Instructions for Receiver'
          name={
            `${fieldNamePrefix}.receiverInstructions` satisfies ReferralProgramConfigurationValuesPaths
          }
        />
        <HelpTip
          icon={<InfoIcon color='primary' />}
          title='Add copy to let the receiver know what referral incentive they’re getting and what conditions have to be met'
        />
        <TextField
          label='Text Message for Receiver'
          name={`${fieldNamePrefix}.smsTemplate` satisfies ReferralProgramConfigurationValuesPaths}
        />
        <HelpTip
          icon={<InfoIcon color='primary' />}
          title={`Parts of this message like ${referralLinkPlaceholder} and ${referralCodePlaceholder} are not editable, but you can still choose their placement and edit copy around it`}
        />
      </Stack>
    </Stack>
  );
};
